export default __webpack_public_path__ + "static/media/skill.ac6ae73b.png";